export default () => ({
  search: {
    popstate: false,
    items: [],
    pagination: {
      limit: 36,
      offset: 0,
      countTotal: 0,
    },
    sort: '',
    activeFilters: {},
    filters: [],
    breadcrumbs: [],
    sortFilters: [],
    categoryId: '',
    categoryName: '',
    categoryLevel: '',
    categoryFilter: [],
    categories: [],
    query: '',
    resetFiltersFlag: false,
    inkAndTonersOnly: '',
    oemCode: '',
    promotionGroupId: null,
    brandId: null,
    catalogSubsetId: null,
    fuzzySearch: null,
    device: '',
    deviceBrand: '',
    deviceModel: '',
    onlyPalletPacks: false,
  },
  products: {
    popstate: false,
    items: [],
    pagination: {
      limit: 36,
      offset: 0,
      countTotal: 0,
    },
    sort: '',
    activeFilters: {},
    sortFilters: [],
    period: 30,
  },
  offers: {
    popstate: false,
    items: [],
    pagination: {
      limit: 36,
      offset: 0,
      countTotal: 0,
    },
    sort: '',
    activeFilters: {},
    sortFilters: [],
  },
  prices: {
    popstate: false,
    items: [],
    pagination: {
      limit: 36,
      offset: 0,
      countTotal: 0,
    },
    sort: '',
    activeFilters: {},
    sortFilters: [],
  },
  list: {
    popstate: false,
    items: [],
    pagination: {
      limit: 36,
      offset: 0,
      countTotal: 0,
    },
    sort: '',
    activeFilters: {},
    sortFilters: [],
  },
  limitFilters: {
    popstate: false,
    name: 'Pokaż',
    key: 'list',
    type: 'radio',
    values: [
      {
        label: '36',
        value: 36,
      },
      {
        label: '60',
        value: 60,
      },
    ],
  },
  periodFilters: {
    popstate: false,
    name: 'Okres',
    key: 'period',
    type: 'radio',
    values: [
      {
        label: 'Dzień',
        value: 1,
      },
      {
        label: 'Tydzień',
        value: 7,
      },
      {
        label: 'Miesiąc',
        value: 30,
      },
      {
        label: 'Kwartał',
        value: 90,
      },
      {
        label: 'Rok',
        value: 365,
      },
    ],
  },
});
